module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_36.1b738739.jpeg";